import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore';
import WorkdocStore from '../../stores/WorkdocStore';
import TextFieldModal from '../../component/element/TextFieldModal'

const DEFAULT_ROW = 1
const MAX_NUM_ROW = 18
var NotificationSystem = require('react-notification-system');
class PrintKKCContractorQuotationDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {report_title:'กำลังดึงข้อมูล..',fontSize:'sm',loading:false,orderlist:[],company:{},meta:{},car:{},owner:{},insurer:{},employee:{},dataImg:{files:[]},dataList:[]}

    this.pcInput = new Array(DEFAULT_ROW).fill('')

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    // this.loadFup('quotation_job')
    this.loadKKCContractorQuotationDoc()
  }

  // loadFup(cat) {
  //   let workNo = this.props
  //   let that = this
  //   WorkdocStore.loadFup(workNo.workNo,cat,function(result) {
  //     that.setState({dataImg:result.data})
  //   })
  // }

  loadKKCContractorQuotationDoc() {
    let workNo = this.props
    this.setState({loading:true})
    PdfStore.loadKKCContractorQuotationDoc(this.props.workNo,this.props.employee_id,(result)=> {
      WorkdocStore.loadFup(workNo.workNo,'quotation_job',(resultImg)=> {
        this.setState({report_title:'ไม่พบข้อมูล',dataImg:resultImg.data,dataList:this.getPagination(result.orderlist,resultImg.data),loading:false,orderlist:result.orderlist,company:result.company,car:result.work.car,owner:result.work.owner,insurer:result.work.insurer,employee:result.employee,meta:result.meta})
      })
    })
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {added_by:'',added_date:'',bf_fixing_order_item_id:'',detail:'',employee_id:'',quantity:'',seq:'',total_cost:'',total_paid:'',withdraw1:'',withdraw2:'',work_no:''}
    })
  }  

  onRowAdd(data,number=1) {
    data = this.newEmptyRow(number)
    
    this.pcInput = new Array(data.length).fill('')
    return data
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getTotal() {
    let sum = 0
    let {orderlist} = this.state
    orderlist.forEach(function(item,index) {
      let total_cost = (item.total_cost===''||item.total_cost===null||item.total_cost===undefined||isNaN(item.total_cost)?0:item.total_cost*1)
      let quantity = (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity*1)
      sum += (total_cost*quantity)
    })
    return sum
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderAdditionalText(company){
    if(company.additional_text!==undefined){
      return (<p style={{lineHeight:'0.7'}}>{company.additional_text} </p>)
    }else{
      return ('')
    }
  }

  renderRowSummary() {
    let {fontSize} = this.state
    return(
              <tr>
                <td className='text-center'></td>
                <td className={'font-'+fontSize+' text-center'}>รวม</td>
                <td className='text-center'></td>
                <td className={'font-'+fontSize+' text-right'}>{this.getNumberFormat(this.getTotal())}</td>
              </tr>
    )
  }

  renderComponentPage(item,index){
    let {company,car,owner,insurer,employee,meta,fontSize} = this.state
    let {approved_by,approved_by_job_position} = meta
    return (
      <div className='font-print' key={index}>
        <header>
          <h2 className="text-right">{'ใบเสนอราคา'}</h2>
        </header>  
        <article className={"article-company "+company.logo_class}>
          <div style={{width:company.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(company.logo_url)}
          </div>
          <section className="font-20" style={{paddingTop:(company.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{company.company_name} (สำนักงานใหญ่)</p>
              <p style={{lineHeight:'0.7'}}>{company.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {company.company_tel} โทรสาร {company.company_fax}</p>
              {this.renderAdditionalText(company)}
            </strong>
          </section>
        </article>
        <br/>
        <br/>
        <div>
          <table className='table table-kkc-contractor-quotation-doc'>
            <tbody>
              <tr>
                <td rowSpan={2} className={'font-'+fontSize+' text-center'} style={{width:'60px',verticalAlign:'middle'}}>
                  แบบรถ<br/><br/>ชนิดรถ
                </td>
                <td rowSpan={2} className={'font-'+fontSize+' text-center'} style={{verticalAlign:'middle',width:'240px'}}>หมายเลขทะเบียน</td>
                <td style={{width:'100px'}} className={'font-'+fontSize}>เจ้าของรถ</td>
                <td style={{width:'10px'}} className={'font-'+fontSize+' text-center'}>:</td>
                <td className={'font-'+fontSize}>{owner.name}</td>
              </tr>
              <tr>
                <td className={'font-'+fontSize}>บริษัท ประกันภัย</td>
                <td className={'font-'+fontSize+' text-center'}>:</td>
                <td className={'font-'+fontSize}>{insurer.insurer_name}</td>
              </tr>
              <tr>
                <td className={'font-'+fontSize+' text-center'}>{car.car_type}</td>
                <td className={'font-'+fontSize+' text-center'}>{car.car_registration_no}</td>
                <td className={'font-'+fontSize}>แผนก</td>
                <td className={'font-'+fontSize+' text-center'}>:</td>
                <td className={'font-'+fontSize}>{employee.department} ทีม {employee.name}</td>
              </tr>
              <tr>
                <td className={'font-'+fontSize+' text-center'}></td>
                <td className={'font-'+fontSize+' text-center'}>{car.brand} - {car.car_no!==undefined?car.car_no:''}</td>
                <td className={'font-'+fontSize}>วันที่ออกเอกสาร</td>
                <td className={'font-'+fontSize+' text-center'}>:</td>
                <td className={'font-'+fontSize}>{meta.fixing_order_date}</td>
              </tr>
            </tbody>
          </table>
          <table className='table table-kkc-contractor-quotation-doc'>
            <tbody>
              <tr>
                <td className={'font-'+fontSize+' text-center hr-top-none'} style={{width:'60px'}}>ลำดับ<br/><br/>ที่</td>
                <td className={'font-'+fontSize+' text-center hr-top-none'} style={{width:'470px'}}>รายการค่าแรงซ่อม</td>
                <td className={'font-'+fontSize+' text-center hr-top-none'} style={{width:'50px'}}>จำนวน<br/><br/>ชิ้น</td>
                <td className={'font-'+fontSize+' text-center hr-top-none'}>ค่าแรง<br/><br/>บาท</td>
              </tr>
              {this.renderRowData(item,index)}
              {this.renderRowImg(item,index)}              
              {this.renderRowEmpty(item,index)}
              {item.summary ? this.renderRowSummary() : ''}
            </tbody>
          </table>
          <div className='footer-page'>
            <div>
              <table className='table table-kkc-contractor-quotation-doc-2'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>ลงชื่อ........................................ผู้เสนอราคา</div>
                      <div>........................................</div>
                    </td>
                    <td className='text-center'>
                      <div>ลงชื่อ........................................ผู้อนุมัติ</div>
                      {approved_by===undefined || approved_by==='' ? (<div>........................................</div>):
                      (
                        <div>
                          <div>({approved_by})</div>
                          <div>{approved_by_job_position}</div>
                        </div>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <table className='table table-kkc-contractor-quotation-doc-2'>
                <tbody>
                  <tr>
                    <td className='text-center'>
                      <div>ลงชื่อ........................................ผู้นำเสนอ</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
  } 

  renderRowEmpty(item,index) {
    let number = MAX_NUM_ROW - item.data.length
    if (number===0) {
      return('')
    } else {
      return(
        this.onRowAdd(item.data,number).map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center'><br/></td>
              <td></td>
              <td className='text-center'></td>
              <td className='text-right'></td>
            </tr>
          )
        })
      )
    }
  }

  renderRowData(item,pageNo) {
    let {fontSize} = this.state
    if (item.data.length===0||item.data===undefined) {
      return('')
    } else {
      return(
        item.data.map((item,index) => {
          return(
            <tr key={index}>
              <td className={'font-'+fontSize+' text-center'}>{(pageNo*MAX_NUM_ROW) + index+1}</td>
              <td className={'font-'+fontSize}>{item.detail}</td>
              <td className={'font-'+fontSize+' text-center'}>{item.quantity}</td>
              <td className={'font-'+fontSize+' text-center'}>{this.getNumberFormat(item.total_cost)}</td>
            </tr>
          )
        })
      )
    }
  }  

  renderRowImg(item,index){
    if(item.img.length===0||item.img===undefined){
      return ('')
    }else{
      return (
        <tr>
          <td className='text-center'><br/></td>
          <td className='td-img'>
            <div style={{width:'100%',position:'absolute'}}>
              {this.renderImg(item,index)}
            </div>
          </td>
          <td className='text-center'></td>
          <td className='text-right'></td>
        </tr>
      )
    }
  }

  renderImg(item,index) {
    if (item.img.length===0||item.img===undefined) {
      return('')
    } else {
      return(
        item.img.map((item,index) => {
          let widthImgLeft = '180px'
          if (item.left.height>item.left.width) {
            widthImgLeft = Math.ceil(153 * item.left.width / item.left.height)
          }
          let widthImgRight = '180px'
          if (item.right.height>item.right.width) {
            widthImgRight = Math.ceil(153 * item.right.width / item.right.height)  
          }  

          let marginTop = '0'
          if (index>0)
            marginTop = 160 * index

          return([
            <div style={{float:'left',marginTop:'5px',width:'30%'}}><img style={{width:widthImgLeft}} src={item.left.url} /></div>,
            <div style={{float:'right',marginTop:'5px',width:'70%'}}><img style={{width:widthImgRight}} src={item.right.url} /></div>
          ])
        })
      )
    }
  }

  getPagination(orders,imgs) {
    let checkRow = 0
    let newData = []
    let allData = []
    let summary = false
    orders.forEach(function(item,index) {
      if (checkRow<MAX_NUM_ROW) {
        newData.push(item)
      }
      if (checkRow===(MAX_NUM_ROW-1)||index===orders.length-1) {

        allData.push({
          data:newData,
          img:[],
          summary:summary
        })
        newData = []
        checkRow = -1
      }
      checkRow++
    })
    
    let rowsImg = []
    let checkMatchImg = 0
    let _Index = 0
    imgs.files.forEach(function(item,index) {
      if (checkMatchImg==0) {
        rowsImg.push({
          left:item,
          right:{}
        })
        checkMatchImg++
      } else if (checkMatchImg==1) {
        rowsImg[_Index].right = item
        checkMatchImg = 0
        _Index++
      }
    })

    let _imgs = []
    let usedRow = 0
    if (allData.length>0)
      usedRow = allData[allData.length-1].data.length
    let balRow = MAX_NUM_ROW - usedRow
    rowsImg.forEach(function(item,index) {
      if (balRow<5) {
        _imgs = []
        _imgs.push(item)
        allData.push({
          data:[],
          img:_imgs,
          summary:summary
        })
        balRow = MAX_NUM_ROW - 5
      } else {
        _imgs.push(item)
        allData[allData.length-1].img = _imgs
        balRow = balRow - 5
      }
    })

    if (allData.length>0)
      allData[allData.length-1].summary = true
    return allData
  }

  onFontClick(size) {
    this.setState({fontSize:size})
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render(){
    let {loading,dataList,fontSize} = this.state
    if (dataList.length===0) {
      return(
        <div>
          <PrintPreview 
            loading={loading}
            leftBarTitle={'ใบงานหมายเลข '+this.props.workNo}
          >
            {this.renderNoData()}
          </PrintPreview>
        </div>
      )
    } else {
      return(
        <div>
          <PrintPreview 
            loading={loading} 
            leftBarTitle={'ใบงานหมายเลข '+this.props.workNo}
            defaultFont={fontSize}
            onFontClick={this.onFontClick.bind(this)}
          >
            {dataList.map((item,index)=>{
              return this.renderComponentPage(item,index)
            })}   
          </PrintPreview>
        </div>  
      )
    }  
  }
}  

PrintKKCContractorQuotationDoc.defaultProps = {
  title: '',  
  mode : ''
}
export default PrintKKCContractorQuotationDoc;


// WEBPACK FOOTER //
// ./src/view/print/PrintKKCContractorQuotationDoc.js